import * as React from 'react';

export interface UseBhanzuBuddyQuickChallengeHandlersProps {
  setShowQuickChallenge: (value: {
    open: boolean;
    question: string;
    category: string;
    color: string;
  }) => void;
  setQuickChallengeSnoozeUntil: (value: number) => void;
  resetIdleTimer: () => void;
  quickChallengeContextRef: React.RefObject<{
    questionByBB: string;
  } | null>;
}

export const useBhanzuBuddyQuickChallengeHandlers = ({
  setShowQuickChallenge,
  setQuickChallengeSnoozeUntil,
  resetIdleTimer,
  quickChallengeContextRef,
}: UseBhanzuBuddyQuickChallengeHandlersProps) => {
  const handleQuickChallengeClose = React.useCallback(() => {
    setShowQuickChallenge({
      open: false,
      question: '',
      category: '',
      color: 'underwater-fern-green',
    });
    setQuickChallengeSnoozeUntil(Date.now() + 10 * 60 * 1000); // Snooze for 10 minutes
    resetIdleTimer();
    quickChallengeContextRef.current = null;
  }, [
    resetIdleTimer,
    setShowQuickChallenge,
    setQuickChallengeSnoozeUntil,
    quickChallengeContextRef,
  ]);

  return {
    handleQuickChallengeClose,
  };
};
